/**
 * 解析服务端接口渲染到 script 标签里的 var 数据
 * 默认读取 id="Heziyun-data"
 */
export function parseHeziyunData(scriptId = 'Heziyun-data') {
  const script = document.getElementById(scriptId)
  if (!script) return null

  let code = script.textContent || ''

  // 去除 /* */ 注释
  code = code.replace(/\/\*[\s\S]*?\*\//g, '')

  const result = {}
  const lines = code.split('\n')

  let currentVar = null
  let currentValue = ''
  let braceCount = 0
  let bracketCount = 0
  let inString = false
  let stringChar = ''

  for (const line of lines) {
    const varMatch = line.match(/var\s+(\w+)\s*=/)

    if (varMatch && braceCount === 0 && bracketCount === 0 && !inString) {
      if (currentVar) {
        result[currentVar] = parseHeziyunValue(currentValue)
      }

      currentVar = varMatch[1]
      currentValue = line.substring(line.indexOf('=') + 1).trim()
    } else if (currentVar) {
      currentValue += ' ' + line.trim()
    }

    for (const char of line) {
      if ((char === '"' || char === "'") && !inString) {
        inString = true
        stringChar = char
        continue
      }

      if (char === stringChar && inString) {
        inString = false
        stringChar = ''
        continue
      }

      if (!inString) {
        if (char === '{') braceCount++
        if (char === '}') braceCount--
        if (char === '[') bracketCount++
        if (char === ']') bracketCount--
      }
    }
  }

  if (currentVar) {
    result[currentVar] = parseHeziyunValue(currentValue)
  }

  return result
}

/**
 * 解析单个 JS 变量值
 */
export function parseHeziyunValue(str) {
  str = String(str).trim().replace(/;$/, '')

  try {
    return new Function(`return (${str})`)()
  } catch (e) {
    console.warn('Heziyun 数据解析失败:', str)
    return str
  }
}